
    import { debounce } from 'lodash'
    import { DateTime } from 'luxon'
    import { computed, defineComponent, onBeforeMount, onMounted, onServerPrefetch } from 'vue'
    import { useI18n } from 'vue-i18n-composable'
    import { useRouter } from 'vue-router/composables'

    import { useBreadcrumbsStore } from '@/app/stores/breadcrumbs'
    import { useSearchStore } from '@/app/stores/search'
    import { useHeadful } from '@/common/composables/libs/headful'

    export default defineComponent({
        props: {
            query: {
                type: String,
                default: ''
            }
        },
        setup (props) {
            const headful = useHeadful()
            const i18n = useI18n()
            const router = useRouter()
            const searchStore = useSearchStore()

            const searching = computed(() => searchStore.searching)
            const searchResults = computed(() => searchStore.results)
            const queryValue = computed({
                get: () => searchStore.query,
                set: value => searchStore.query = value
            })

            const formatDate = (date: string): string => {
                return DateTime.fromISO(date).toFormat('d/MM/yyyy')
            }

            const search = debounce(async () => {
                // Do not push empty values, because guard check will fail (query should not be empty)
                if (queryValue.value !== '') {
                    await router.push({
                        name: 'search',
                        params: {
                            query: queryValue.value
                        }
                    })

                    await searchStore.search()
                }
            }, 1000)

            onServerPrefetch(() => searchStore.searching = false)

            onBeforeMount((): void => {
                useBreadcrumbsStore().reset()

                headful({
                    title: `${i18n.t('nav.search-results')} - ${props.query} | ${i18n.t('meta.title')}`
                })
            })

            onMounted(async (): Promise<void> => {
                queryValue.value = props.query

                if (props.query !== '') {
                    searchStore.searching = true
                    await searchStore.search()
                }
            })

            return {
                searching,
                searchResults,
                queryValue,
                formatDate,
                search
            }
        }
    })
